<header class="app-header d-flex align-items-center justify-content-between px-3 px-md-4">
  <div class="left">
    <h4 class="greeting mb-1">{{ greeting }} <span *ngIf="sessionData">{{ sessionData.user.firstName | titlecase }}</span><span *ngIf="!sessionData">Admin</span>!</h4>
    <div class="breadcrumb text-muted">
      <span>Admin / </span><strong>{{ pageTitle }}</strong>
    </div>
  </div>

  <div class="right d-flex align-items-center gap-3">

    <div class="org-name text-muted d-none d-sm-block" *ngIf="!sessionData">Admin</div>
    <div class="org-name text-muted d-none d-sm-block" *ngIf="sessionData">{{ sessionData.user.firstName | titlecase }}</div>
    <!-- Dummy avatar image -->
    <div class="avatar-menu">
      <img
    src="assets/images/profile.png"
    alt="User Avatar"
    class="avatar cursor-pointer"
    (click)="menu.toggle($event)" />

  <p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
    </div>
  </div>
</header>
